module.exports = __webpack_public_path__ + "static/media/light-resource-tag.6d78e9fc.svg";